<form [formGroup]="_filterForm" class="padding">
  <div class="margin-top-bottom-25">
    <div class="flex-container">
      @for (field of _textboxFields; track field) {
        <div class="flex-item">
          <mat-form-field class="form-field">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [formControlName]="field.resourceParameterName" [placeholder]="field?.label ?? ''" />
          </mat-form-field>
        </div>
      }
    </div>

    <div class="flex-container">
      @for (field of _checkboxFields; track field) {
        <div class="form-field flex-item">
          <mat-checkbox [formControlName]="field.resourceParameterName">
            {{ field.label }}
          </mat-checkbox>
        </div>
      }
    </div>

    <div class="flex-container">
      @for (field of _dropdownFields; track field) {
        <div class="flex-item">
          <mat-form-field class="form-field">
            <mat-select [formControlName]="field.resourceParameterName" [placeholder]="field?.label ?? ''"
              [multiple]="field.dropdownListOptions?.multi ?? false">
              @for (option of field.dropdownListOptions?.options; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>

    @if (_jurisdictionField) {
      <lib-jurisdiction-selection></lib-jurisdiction-selection>
    }

    <div class="flex-container">
      @for (field of _datepickerFields; track field) {
        <div class="flex-item">
          @if (!(field.datepickerOptions?.range ?? false)) {
            <mat-form-field class="form-field">
              <input matInput [matDatepicker]="datepicker" [formControlName]="field.resourceParameterName" [placeholder]="field.label ?? ''">
              <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
            </mat-form-field>
          }
          @if (field.datepickerOptions?.range ?? false) {
            <mat-form-field>
              <mat-label>{{ field.label ?? 'Enter a date range'}}</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input [formControlName]="field.resourceParameterName" matStartDate [placeholder]="'filter.startDate' | transloco" [attr.aria-label]="'filter.startDate' | transloco">
                <input [formControlName]="field.datepickerOptions?.range?.beforeDateResourceParameterName ?? ''" matEndDate [placeholder]="'filter.endDate' | transloco" [attr.aria-label]="'filter.endDate' | transloco">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          }
        </div>
      }
    </div>
  </div>

  <div>
    <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
      (click)="onClear()" [disabled]="!_filterForm.dirty">
      {{ 'common.labels.clearFilters' | transloco }}
    </button>
    <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
      (click)="onFilter()">
      {{ 'common.labels.filter' | transloco }}
    </button>
  </div>
</form>